import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import io from 'socket.io-client';
import { jwtDecode } from 'jwt-decode';


const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [invoicesPerPage] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceStates, setInvoiceStates] = useState({});
  const [orderItems, setOrderItems] = useState([]); // New state for order items
  const [searchInvoiceId, setSearchInvoiceId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  ////////////////////// get token user and pass //////////////////
const token = localStorage.getItem("token")
    const decodedToken = jwtDecode(token);

    const username = decodedToken.username;
     const name = decodedToken.name;

const mydb = username.slice(0, 3);

      
//////////////////////



  useEffect(() => {
    fetchInvoices();
  }, []);

  useEffect(() => {
    // Initialize WebSocket connection
    const socket = io('http://localhost:5000');

    // Listen for invoice state updates
    socket.on('invoiceStateUpdate', (data) => {
      console.log('Received invoice state update:', data);

      // Update local state
      setInvoiceStates(prev => ({
        ...prev,
        [data.id]: data.invoice_state
      }));

      // Update invoices list
      setInvoices(prevInvoices =>
        prevInvoices.map(inv =>
          inv.id.toString() === data.id.toString()
            ? { ...inv, invoice_state: data.invoice_state }
            : inv
        )
      );

      // Update selected invoice if it's currently open
      setSelectedInvoice(prevSelected => {
        if (prevSelected && prevSelected.id.toString() === data.id.toString()) {
          return {
            ...prevSelected,
            invoice_state: data.invoice_state
          };
        }
        return prevSelected;
      });

      // Show toast notification
      toast.info(`Invoice state updated to: ${data.invoice_state}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    // Listen for new invoice creation events
    socket.on('invoiceCreated', (data) => {
      console.log('Received new invoice creation:', data);

      // Fetch invoices again or add the new invoice to the list
      fetchInvoices();

      // Show toast notification
      toast.success(`New invoice created for Order #${data.orderid}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await fetch('/myinvoice?mydb='+mydb);
      if (!response.ok) {
        throw new Error('Failed to fetch invoices');
      }
      const data = await response.json();
      // Sort invoices by id descending
      const sortedInvoices = data.sort((a, b) => b.id - a.id);
      setInvoices(sortedInvoices);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const openDeleteModal = (invoiceId) => {
    setInvoiceToDelete(invoiceId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setInvoiceToDelete(null);
    setShowDeleteModal(false);
  };

  const openDetailsModal = async (invoice) => {
    setSelectedInvoice(invoice);
    setShowDetailsModal(true);
    // Fetch order items with order-state "instock" for the invoice's orderid
    if (invoice.orderid) {
      try {
        const response = await fetch(`/orders/${encodeURIComponent(invoice.orderid)}/items?state=instock&mydb=` + mydb);
        if (!response.ok) {
          throw new Error('Failed to fetch order items');
        }
        const data = await response.json();
        setOrderItems(data);
      } catch (error) {
        console.error('Error fetching order items:', error);
        setOrderItems([]);
      }
    } else {
      setOrderItems([]);
    }
  };

  const closeDetailsModal = () => {
    setSelectedInvoice(null);
    setShowDetailsModal(false);
  };

  const handleDelete = async () => {

     if (!invoiceToDelete) return;
    try {
      const response = await fetch(`/invoices/id/${invoiceToDelete}?mydb=`+mydb, {
        method: 'DELETE',
      });
      if (response.ok) {
        setInvoices(invoices.filter(inv => inv.id !== invoiceToDelete));
        toast.success('Invoice deleted successfully', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        throw new Error('Failed to delete invoice');
      }
    } catch (err) {
      console.error('Error deleting invoice:', err);
      toast.error('Failed to delete invoice', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      closeDeleteModal();
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const formatCurrency = (amount, currency = 'USD') => {
    if (amount == null) return '$0.00';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  const handleExportPDF = () => {
    if (!selectedInvoice) {
      toast.error('No invoice selected for PDF export', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const doc = new jsPDF();

    // Add header with company name on left and contact info on right with border and modern style
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const headerHeight = 30;

    // Draw header background rectangle with a modern gradient-like color
    doc.setFillColor(33, 150, 243);
    doc.rect(0, 0, pageWidth, headerHeight, 'F');

    // Add logo image
    const logoPath = '/img/22.png';
    doc.addImage(logoPath, 'PNG', margin, 2, 16, 16);

    // Draw bottom border line for header
    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(1);
    doc.line(0, headerHeight, pageWidth, headerHeight);

    // Company name on left in white bold font
    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.text("Intelligent systems", margin + 20, 14);

    // Contact info on right in white normal font
    const contactInfo = "Contact: info@intelligen.com | +1 234 567 890";
    const contactInfoWidth = doc.getTextWidth(contactInfo);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(contactInfo, pageWidth - margin - contactInfoWidth, 24);

    // Reset font and color for body text
    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.setFont('helvetica', 'normal');
    doc.text(`Invoice #${selectedInvoice.id} Details`, margin, headerHeight + 14);

    doc.setFontSize(12);
    doc.text(`Client: ${selectedInvoice.client_name}`, margin, headerHeight + 24);
    doc.text(`Phone 1: ${selectedInvoice.tel1 || 'N/A'}`, margin, headerHeight + 32);
    doc.text(`Phone 2: ${selectedInvoice.tel2 || 'N/A'}`, margin, headerHeight + 40);
    doc.text(`Address: ${selectedInvoice.address || 'N/A'}`, margin, headerHeight + 48);
    doc.text(`Date: ${formatDate(selectedInvoice.date)}`, margin, headerHeight + 56);
    doc.text(`Amount: ${formatCurrency(selectedInvoice.amount)}`, margin, headerHeight + 64);
    doc.text(`Payment Method: ${selectedInvoice.paymentmethod || 'N/A'}`, margin, headerHeight + 72);

    // Prepare table data
    const tableColumn = ["Item Name", "Quantity", "Price"];
    const tableRows = [];

    orderItems.forEach(item => {
      const itemData = [
        item.name,
        item.quantity.toString(),
        formatCurrency(item.price)
      ];
      tableRows.push(itemData);
    });

    autoTable(doc, {
      startY: headerHeight + 84,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [33, 150, 243], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 248, 255] },
      margin: { left: margin, right: margin },
      tableLineColor: [33, 150, 243],
      tableLineWidth: 0.5,
    });

    doc.save(`Invoice_${selectedInvoice.id}.pdf`);
  };

  const handleExportPDFAndSendWhatsApp = () => {
    if (!selectedInvoice) {
      toast.error('No invoice selected for PDF export', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const invoice = selectedInvoice;

    let messageText = `Invoice #${invoice.id} Details:\n`;
    messageText += `Client: ${invoice.client_name}\n`;
    messageText += `Phone 1: ${invoice.tel1 || 'N/A'}\n`;
    messageText += `Phone 2: ${invoice.tel2 || 'N/A'}\n`;
    messageText += `Address: ${invoice.address || 'N/A'}\n`;
    messageText += `Date: ${formatDate(invoice.date)}\n`;
    messageText += `Amount: ${formatCurrency(invoice.amount)}\n`;
    messageText += `Payment Method: ${invoice.paymentmethod || 'N/A'}\n\n`;
    messageText += `Items:\n`;

    orderItems.forEach(item => {
      messageText += `- ${item.name}, Qty: ${item.quantity}, Price: ${formatCurrency(item.price)}\n`;
    });

    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    const headerHeight = 30;

    doc.setFillColor(33, 150, 243);
    doc.rect(0, 0, pageWidth, headerHeight, 'F');

    const logoPath = '/img/22.png';
    //doc.addImage(logoPath, 'PNG', margin, 2, 16, 16);

    doc.setDrawColor(255, 255, 255);
    doc.setLineWidth(1);
    doc.line(0, headerHeight, pageWidth, headerHeight);

    doc.setFontSize(16);
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.text("A2Zskincare", margin + 20, 14);

    const contactInfo = "Contact:  | 78 920826";
    const contactInfoWidth = doc.getTextWidth(contactInfo);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(contactInfo, pageWidth - margin - contactInfoWidth, 24);

    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.setFont('helvetica', 'normal');
    doc.text(`Invoice #${invoice.id} Details`, margin, headerHeight + 14);

    doc.setFontSize(12);
    doc.text(`Client: ${invoice.client_name}`, margin, headerHeight + 24);
    doc.text(`Phone 1: ${invoice.tel1 || 'N/A'}`, margin, headerHeight + 32);
    doc.text(`Phone 2: ${invoice.tel2 || 'N/A'}`, margin, headerHeight + 40);
    doc.text(`Address: ${invoice.address || 'N/A'}`, margin, headerHeight + 48);
    doc.text(`Date: ${formatDate(invoice.date)}`, margin, headerHeight + 56);
    doc.text(`Amount: ${formatCurrency(invoice.amount)}`, margin, headerHeight + 64);
    doc.text(`Payment Method: ${invoice.paymentmethod || 'N/A'}`, margin, headerHeight + 72);

    const tableColumn = ["Item Name", "Quantity", "Price"];
    const tableRows = [];

    orderItems.forEach(item => {
      const itemData = [
        item.name,
        item.quantity.toString(),
        formatCurrency(item.price)
      ];
      tableRows.push(itemData);
    });

    autoTable(doc, {
      startY: headerHeight + 84,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [33, 150, 243], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 248, 255] },
      margin: { left: margin, right: margin },
      tableLineColor: [33, 150, 243],
      tableLineWidth: 0.5,
    });

    const pdfBase64 = doc.output('datauristring');

    const pdfUrl = `https://example.com/invoices/Invoice_${invoice.id}.pdf`;

   // const fullMessage = encodeURIComponent(`${messageText}\nPDF Invoice: ${pdfUrl}`);


   const fullMessage = encodeURIComponent(`${messageText}\n`);
    const phone = (invoice.tel1 || '').replace(/\D/g, '');
    const whatsappUrl = `https://wa.me/${phone}?text=${fullMessage}`;

    window.open(whatsappUrl, '_blank');

    toast.info('WhatsApp Web opened with invoice details and PDF link.', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  // Pagination logic
  const indexOfLastInvoice = currentPage * invoicesPerPage;
  const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;

  // Filter invoices by search and date range
  let filteredInvoices = invoices;

  if (searchInvoiceId) {
    const searchTerm = searchInvoiceId.toLowerCase();
    filteredInvoices = filteredInvoices.filter(inv => 
      inv.id.toString().toLowerCase().includes(searchTerm) ||
      (inv.client_name && inv.client_name.toLowerCase().includes(searchTerm)) ||
      (inv.orderid && inv.orderid.toLowerCase().includes(searchTerm))
    );
  }

  if (startDate) {
    const start = new Date(startDate);
    filteredInvoices = filteredInvoices.filter(inv => new Date(inv.date) >= start);
  }

  if (endDate) {
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    filteredInvoices = filteredInvoices.filter(inv => new Date(inv.date) <= end);
  }

  const currentInvoices = filteredInvoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
  const totalPages = Math.ceil(filteredInvoices.length / invoicesPerPage);

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      width: '100%',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'wrap'
        }}>
          <a href="/"
            style={{
              padding: '10px 20px',
              backgroundColor: '#3498db',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#2980b9';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <span style={{ fontSize: '18px' }}>←</span>
            Home
          </a>
          
          {/* Search Input */}
          <input
            type="text"
            placeholder="Search by Invoice ID, Client or Order ID..."
            value={searchInvoiceId}
            onChange={(e) => setSearchInvoiceId(e.target.value)}
            style={{
              padding: '8px 12px',
              border: '1px solid #dce4ec',
              borderRadius: '8px',
              fontSize: '14px',
              width: '250px'
            }}
          />
          
          {/* Clear Button */}
          {searchInvoiceId && (
            <button
              onClick={() => setSearchInvoiceId('')}
              style={{
                padding: '8px 12px',
                backgroundColor: '#95a5a6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Clear
            </button>
          )}
          {/* Date Filter Inputs */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label htmlFor="startDate" style={{ fontSize: '14px', color: '#2c3e50' }}>Start Date:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #dce4ec',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer',
                maxWidth: '150px'
              }}
            />
            <label htmlFor="endDate" style={{ fontSize: '14px', color: '#2c3e50' }}>End Date:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                padding: '6px 10px',
                border: '1px solid #dce4ec',
                borderRadius: '8px',
                fontSize: '14px',
                cursor: 'pointer',
                maxWidth: '150px'
              }}
            />
            {(startDate || endDate) && (
              <button
                onClick={() => {
                  setStartDate('');
                  setEndDate('');
                }}
                style={{
                  padding: '6px 12px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Clear Dates
              </button>
            )}
          </div>
        </div>
        
        <div style={{
          backgroundColor: '#27ae60',
          color: 'white',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          Total Invoices: {filteredInvoices.length}
        </div>
      </div>

      <h1 style={{
        color: '#2c3e50',
        textAlign: 'center',
        marginBottom: '30px',
        fontSize: '2.5rem',
        fontWeight: '300',
        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>Invoices Management</h1>

      {loading ? (
        <div style={{ padding: '20px', textAlign: 'center', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>Loading...</div>
      ) : error ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#e74c3c', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>{error}</div>
      ) : filteredInvoices.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', color: '#7f8c8d', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>No invoices found</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {currentInvoices.map((invoice) => (
            <div key={invoice.id} style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              transition: 'transform 0.2s ease',
              cursor: 'pointer',
            }}
            onClick={() => openDetailsModal(invoice)}
            onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)' }}
            onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #2196f3 0%, #c0c0c0 100%)',
                padding: '15px 20px',
                color: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.2)'
              }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(45deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%)',
                pointerEvents: 'none'
              }}/>
                <div style={{ fontSize: '18px', fontWeight: '600' }}>
                  Invoice #{invoice.id}
                </div>
                <div style={{ fontSize: '14px' }}>
                  {formatDate(invoice.date)}
                </div>
              </div>
              <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontSize: '16px', color: '#34495e', marginBottom: '5px' }}>
                    Client: {invoice.client_name}
                  </div>
                  <div style={{ fontSize: '16px', color: '#34495e' }}>
                    Order ID: {invoice.orderid}
                  </div>
                  <div style={{ fontSize: '16px', color: '#34495e' }}>
                    Amount: {formatCurrency(invoice.amount)}
                  </div>
                  <div style={{ 
                    fontSize: '16px', 
                    color: invoice.invoice_state === 'paid' ? '#27ae60' : '#e67e22',
                    fontWeight: invoice.invoice_state === 'paid' ? '600' : '500',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}>
                    State: {invoice.invoice_state || 'N/A'}
                    {invoice.invoice_state === 'paid' ? (
                      <span role="img" aria-label="happy face" style={{ fontSize: '18px' }}>😊</span>
                    ) : (
                      <span role="img" aria-label="warning" style={{ fontSize: '18px' }}>⚠️</span>
                    )}
                  </div>
                  <div style={{ fontSize: '16px', color: '#34495e' }}>
                    Payment Method: {invoice.paymentmethod || 'N/A'}
                  </div>
                  <div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        const orderId = invoice.orderid;
                        if (orderId) {
                          const url = `/orders?searchOrderId=${encodeURIComponent(orderId)}?mydb=`+mydb;
                          window.open(url, '_blank');
                        } else {
                          alert('Order ID not available');
                        }
                      }}
                      style={{
                        display:'none',
                        marginTop: '8px',
                        padding: '6px 12px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'background-color 0.3s ease',
                        marginRight: '10px'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = '#2980b9';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = '#3498db';
                      }}
                    >
                      Full Order
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openDeleteModal(invoice.id);
                      }}
                      disabled={invoice.invoice_state === 'paid'}
                      style={{
                        marginTop: '8px',
                        padding: '6px 12px',
                        backgroundColor: invoice.invoice_state === 'paid' ? '#95a5a6' : '#e74c3c',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: invoice.invoice_state === 'paid' ? 'not-allowed' : 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'background-color 0.3s ease',
                      }}
                      onMouseOver={(e) => {
                        if (!e.target.disabled) e.target.style.backgroundColor = '#c0392b';
                      }}
                      onMouseOut={(e) => {
                        if (!e.target.disabled) e.target.style.backgroundColor = '#e74c3c';
                      }}
                      title={invoice.invoice_state === 'paid' ? 'Cannot delete a paid invoice' : 'Delete Invoice'}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Controls */}
      {!loading && !error && filteredInvoices.length > 0 && (
        <div style={{ 
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          marginTop: '20px'
        }}>
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage === 1 ? '#e9ecef' : '#3498db',
                color: currentPage === 1 ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Previous
            </button>
            <span style={{ 
              display: 'flex', 
              alignItems: 'center',
              color: '#2c3e50',
              fontSize: '14px'
            }}>
              Page {currentPage} of {totalPages} ({filteredInvoices.length} invoices)
            </span>
            <button
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              disabled={currentPage >= totalPages}
              style={{
                padding: '8px 16px',
                backgroundColor: currentPage >= totalPages ? '#e9ecef' : '#3498db',
                color: currentPage >= totalPages ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer',
                fontSize: '14px'
              }}
            >
              Next
            </button>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <h3 style={{ marginBottom: '20px', color: '#e74c3c' }}>Confirm Delete</h3>
            <p style={{ marginBottom: '30px' }}>Are you sure you want to delete this invoice?</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#c0392b';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#e74c3c';
                }}
              >
                Delete
              </button>
              <button
                onClick={closeDeleteModal}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#7f8c8d';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#95a5a6';
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal */}
      {showDetailsModal && selectedInvoice && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, color: '#2c3e50' }}>Invoice #{selectedInvoice.id} Details</h2>
              <button
                onClick={closeDetailsModal}
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  padding: '5px',
                  color: '#95a5a6',
                }}
              >
                ×
              </button>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Order ID:</strong> {selectedInvoice.orderid}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Client Name:</strong> {selectedInvoice.client_name}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Client ID:</strong> {selectedInvoice.client_id}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Phone 1:</strong> {selectedInvoice.tel1 || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Phone 2:</strong> {selectedInvoice.tel2 || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Address:</strong> {selectedInvoice.address || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Note:</strong> {selectedInvoice.note || '-'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Payment Method:</strong> {selectedInvoice.paymentmethod || 'N/A'}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Amount:</strong> {formatCurrency(selectedInvoice.amount)}
              </p>
              <p style={{ margin: '5px 0', fontSize: '16px' }}>
                <strong>Order Items (In Stock):</strong>
              </p>
              {orderItems.length === 0 ? (
                <p style={{ margin: '5px 0', fontSize: '14px', fontStyle: 'italic' }}>No items in stock for this order.</p>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '15px' }}>
                  <thead>
                    <tr>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Item Name</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Quantity</th>
                      <th style={{ borderBottom: '1px solid #ccc', padding: '8px', textAlign: 'right' }}>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems.map((item) => (
                      <tr key={item.id}>
                        <td style={{ borderBottom: '1px solid #eee', padding: '8px' }}>{item.name}</td>
                        <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{item.quantity}</td>
                        <td style={{ borderBottom: '1px solid #eee', padding: '8px', textAlign: 'right' }}>{formatCurrency(item.price)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
      <p style={{ margin: '5px 0', fontSize: '16px' }}>
        <strong>Invoice State:</strong>{' '}
        <select
          value={selectedInvoice.invoice_state || 'pending'}
          onChange={async (e) => {
            const newState = e.target.value;
            try {
              const response = await fetch(`/invoices/${selectedInvoice.id}/state?mydb=`+mydb, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ invoice_state: newState }),
              });
              if (!response.ok) {
                throw new Error('Failed to update invoice state');
              }
              // Update local state
              setInvoices((prevInvoices) =>
                prevInvoices.map((inv) =>
                  inv.id === selectedInvoice.id ? { ...inv, invoice_state: newState } : inv
                )
              );
              setSelectedInvoice((prev) => ({ ...prev, invoice_state: newState }));
              toast.success('Invoice state updated successfully');
            } catch (error) {
              toast.error('Error updating invoice state');
            }
          }}
          style={{
            padding: '6px 10px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
        </select>
      </p>
      <div style={{ 
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid #dee2e6',
        paddingTop: '20px'
      }}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleExportPDF();
          }}
          style={{
            padding: '12px 24px',
            backgroundColor: '#e74c3c',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#c0392b';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#e74c3c';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          <span style={{ fontSize: '18px' }}>📄</span>
          Export PDF
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleExportPDFAndSendWhatsApp();
          }}
          style={{
            marginLeft: '10px',
            padding: '12px 24px',
            backgroundColor: '#25D366',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#1ebe57';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#25D366';
            e.target.style.transform = 'translateY(0)';
          }}
          title="Send PDF via WhatsApp"
        >
          <span style={{ fontSize: '18px' }}>📱</span>
          WhatsApp
        </button>
      </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Invoices;
